import courseClassService from '@/services/api/course/class';
import enrollmentService from '@/services/api/course/enrollment';
import creditsService from '@/services/api/course/credits';

export default {
  namespaced: true,
  modules: {
    class: courseClassService,
    enrollment: enrollmentService,
    credits: creditsService,
  },
};
